/*
 * Copyright (C) Fraunhofer IESE 2021-2024 - Pedram (Majid) Jokar, Mher Ter-Tovmasyan,
 * Bestin John, Steffen Hupp, Anna Kleiner, Rafael Aranda Lopez King, Emily Calvet, Philipp Ewen,
 * Matthias Gerbershagen, Milad Chatrangoon, Stefan Schweitzer
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import {
  SLRAuthProvider,
  SLRFormProvider,
  SLRLibraryProvider,
  SLRToastProvider
} from '@slr/shared-library';
import 'assets/icons';
import {
  authConfiguration,
  formConfiguration,
  libraryConfiguration,
  toastConfiguration
} from 'configs';
import { Layout } from 'layout';
import 'localization';
import { UserPortalRouting } from 'pages';
import { QueryParamProvider } from 'providers';
import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider
} from 'react-router';
import './theme/index.scss';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <QueryParamProvider>
          <Layout>
            <Outlet />
          </Layout>
        </QueryParamProvider>
      }
    >
      <Route path="*" element={<UserPortalRouting />} />
    </Route>
  )
);

root.render(
  <SLRAuthProvider {...authConfiguration}>
    <React.StrictMode>
      <SLRLibraryProvider {...libraryConfiguration}>
        <SLRToastProvider {...toastConfiguration}>
          <SLRFormProvider {...formConfiguration}>
            <RouterProvider router={router} />
          </SLRFormProvider>
        </SLRToastProvider>
      </SLRLibraryProvider>
    </React.StrictMode>
  </SLRAuthProvider>
);
